export default "__VITE_ASSET__CXxuQv09__"